import { renderRichText } from './richText'
import type { HubIntroSection, HubSectionComponentProps } from './types'

export function HubIntro({
  section,
}: HubSectionComponentProps<HubIntroSection>) {
  const paragraphs = section.body
    .split(/\n\n+/)
    .map((p) => p.trim())
    .filter(Boolean)

  if (paragraphs.length === 0) return null

  return (
    <section
      id={section.id}
      aria-label={section.title ?? 'Introduction'}
      className='flex flex-col gap-4'
    >
      {section.title && (
        <h2 className='font-display text-2xl font-bold leading-8 text-foreground'>
          {section.title}
        </h2>
      )}
      {section.dek && (
        <p className='text-base leading-6 text-foreground-secondary'>
          {section.dek}
        </p>
      )}
      <div className='flex flex-col gap-4 text-base leading-7 text-foreground'>
        {paragraphs.map((paragraph, i) => (
          <p key={i}>{renderRichText(paragraph)}</p>
        ))}
      </div>
    </section>
  )
}
